import { render } from "./Empty.vue?vue&type=template&id=6ac60c32"
import script from "./Empty.vue?vue&type=script&setup=true&lang=js"
export * from "./Empty.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/base/layouts/Empty.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ac60c32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ac60c32', __exports__)) {
    api.reload('6ac60c32', __exports__)
  }
  
  module.hot.accept("./Empty.vue?vue&type=template&id=6ac60c32", () => {
    api.rerender('6ac60c32', render)
  })

}


export default __exports__